import { StrictRouteConfig } from "@/router/router";

export const miscRoutes: StrictRouteConfig[] = [
    {
        path: "/",
        name: "dashboard",
        component: () => import(/* webpackChunkName: "misc" */ "@/views/misc/dashboard.vue"),
        meta: {
            requiresAuth: true,
            label: "Dashboard",
            includeInNavigation: true,
            icon: "monitor-dashboard",
            matchExact: true,
            path: ["dashboard"],
            order: 10,
        },
    },
    {
        path: "/checkin/:officeId/:officeName",
        name: "checkin",
        component: () => import(/* webpackChunkName: "misc" */ "@/views/misc/checkin.vue"),
        meta: {
            requiresAuth: false,
            includeInSubNavigation: true,
            hideNavbar: true,
            icon: "qrcode",
            label: "Check-in page",
            order: 40,
        },
    },
];
